/** The palette asks the server once the query has this many characters. */
export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 200;

/*
 * A task reference: a project key (a letter, then letters or digits) and a number, "NOON-12",
 * or "T" and a number for a task outside any project, "T-12".
 */
const TASK_REFERENCE = /^(?:[A-Za-z][A-Za-z0-9]{1,9}|[Tt])-\d{1,7}$/;

export function isSearchable(query: string): boolean {
  return query.trim().length >= MIN_SEARCH_LENGTH;
}

/** "noon-12 " reads as the reference NOON-12; anything else is not a reference. */
export function referenceIn(query: string): string | null {
  const trimmed = query.trim();
  return TASK_REFERENCE.test(trimmed) ? trimmed.toUpperCase() : null;
}
